import React, { useState, useEffect } from 'react';
import { HomeButton } from '../../components/website/HomeButton';
import axios from 'axios';
import { API_ENDPOINTS } from '../../config/apiConfig';

const ACTRegistration = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false);

    useEffect(() => {
        let errorTimer;

        if (error) {
            errorTimer = setTimeout(() => {
                setError('');
            }, 5000);
        }

        return () => {
            if (errorTimer) {
                clearTimeout(errorTimer);
            }
        }
    }, [error]);

    const handleRegister = async () => {

        setIsLoading(true);
        try {
            const response = await axios.post(API_ENDPOINTS.registerACT, {
                email
            });
            setIsRegistered(true);
            setIsLoading(false);
            console.log(response.data);
        } catch (error) {
            setError(error.response.data.error);
            console.log(error.response.data.error);
            setIsLoading(false);
        }
    }

    return (
        <div className="flex flex-col items-center justify-start min-h-screen font-inter text-gray-800 pt-16 font-nunito">
            {/* <div className="flex flex-col justify-start mt-12 w-full">
                {isRegistered ? (
                    <div className="flex flex-col items-center text-center font-inter text-gray-800 px-5 sm:px-0">
                        <h1 className="text-2xl sm:text-3xl mb-6">Thank you for registering!</h1>
                        <p className="text-base sm:text-xl leading-relaxed">We will send you an email with instructions to create your account with the free trial.</p>
                        <p className="text-base sm:text-xl leading-relaxed">In the meantime, check out our products <a href="/calculator" className="text-blue-600 hover:underline">here</a>.</p>
                    </div>
                ) : (
                    <div className="w-full">
                        <div className="flex flex-col items-center font-inter text-gray-800 mx-5 sm:mx-24 text-center sm:text-left">
                            <h1 className="text-2xl sm:text-3xl mb-6">ACT Registration</h1>
                            <p className="text-base sm:text-xl leading-relaxed"> Welcome to AmpTrans! Enter your email below to register for the waitlist for a free trial for our enterprise plan.</p>

                            <p className="text-base sm:text-xl leading-relaxed mt-4">
                                We will send you an email with instructions to create your account with the free trial.
                            </p>

                            <p className="text-base sm:text-xl leading-relaxed mt-4">
                                This promotion for a 3-month free trial is available until May 8th, 2025.
                            </p>
                            {error && <p className="text-red-500 text-lg leading-relaxed border-2 border-red-500 rounded-2xl p-2.5 m-2.5 bg-red-100">{error}</p>}
                        </div>

                        <div className="flex flex-col items-center mt-5">
                            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-4/5 sm:w-1/2 p-2.5 my-5 rounded-2xl border border-solid" />
                            <button className="btn-primary" onClick={handleRegister}>Register</button>
                        </div>
                    </div>
                )}
            </div> */}
            <div className="flex flex-col items-center justify-start min-h-screen font-inter text-gray-800 pt-16 font-nunito">
                <h2 className="text-2xl sm:text-3xl mb-6">
                    If you are interested in the free trial, please reach out to <a href="mailto:info@amptrans.com" className="text-blue-600 hover:underline">info@amptrans.com</a> for registration details.
                </h2>
            </div>
        </div>
    );
};

export default ACTRegistration;

